// extracted by mini-css-extract-plugin
export default {"bCorp":"BCorpContainer-module_bCorp__yalp1"};